import React, { Fragment, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { string, object, number, array } from 'yup';
import { translate } from '../Services/translation';
import { ViewMode } from '../constants';
import ReturnSearch from '../ComponentsBrafab/Returns/ReturnSearch.js';
import PendingReturnDetails from '../ComponentsBrafab/Returns/PendingReturnDetails.js';
import {
    changeMode,
    updateRow,
    updateRowClassification,
    setError,
    submit,
    query,
    searchArticle,
    add,
    deletePendingRow,
    uploadImages
} from '../ActionsBrafab/Returns.action.js';

const ReturnsContainer = () => {
    const dispatch = useDispatch();
    const { mode } = useSelector((state) => state.myPage.returns);

    useEffect(() => {
        dispatch(query());
    }, [dispatch]);

    const showList = useCallback(() => {
        dispatch(changeMode(ViewMode.List));
    }, [dispatch]);

    const showDetails = useCallback(() => {
        dispatch(changeMode(ViewMode.Edit));
    }, [dispatch]);

    const search = useCallback((searchText) => {
        dispatch(searchArticle(searchText));
    }, [dispatch]);

    const onAdd = useCallback((orderId, articleNumber, returnId, orderArticleIndex, orderArticleOrderIndex) => {
        dispatch(add(orderId, articleNumber, returnId, orderArticleIndex, orderArticleOrderIndex));
    }, [dispatch]);

    const onDelete = useCallback((returnId, rowSystemId, orderArticleIndex, orderArticleOrderIndex) => {
        dispatch(deletePendingRow(returnId, rowSystemId, orderArticleIndex, orderArticleOrderIndex));
    }, [dispatch]);

    const returnSchema = object().shape({
        returnReason: string().required(translate('code.mypage.returndetails.validation.mustchooseoption')).nullable(),
        suggestedSolutionOption: string().required(translate('code.mypage.returndetails.validation.mustchooseoption')).nullable(),
        returnedQuantity: number().min(1, translate('code.mypage.returndetails.validation.mustaddvalue')),
        contactPerson: string().required(translate('code.mypage.returndetails.validation.mustaddvalue')).nullable(),
        comments: string().required(translate('code.mypage.returndetails.validation.mustaddvalue')).nullable(),
        suggestedSolution: string()
            .required(translate('code.mypage.returndetails.validation.adddetailedsuggestion'))
            .min(7, translate('code.mypage.returndetails.validation.adddetailedsuggestion')).nullable(),
        deliveryNumber: string().when('returnReason', {
            is: '1',
            then: string().required(translate('code.mypage.returndetails.validation.mustaddvalue')).nullable()
        }).nullable(),
        deliveryDateReceived: string().when('returnReason', {
            is: '1',
            then: string().required(translate('code.mypage.returndetails.validation.mustaddvalue')).nullable()
        }).nullable(),
        numberOfDamagedCases: number().when('returnReason', {
            is: '1',
            then: number().min(1, translate('code.mypage.returndetails.validation.mustaddvalue'))
        }),
        images: array().min(1, translate('code.mypage.returndetails.validation.images'))
    });

    return (
        <div className="returns__container">
            <div id="returnsLoader" className="generic-loader"></div>

            {mode === ViewMode.List && (
                <ReturnSearch
                    showDetails={showDetails}
                    onSearch={search}
                    add={onAdd}
                    deletePendingRow={onDelete}
                    returnSchema={returnSchema}
                    setError={setError}
                />
            )}
            {mode === ViewMode.Edit && (
                <PendingReturnDetails
                    showList={showList}
                    updateRow={updateRow}
                    updateRowClassification={updateRowClassification}
                    submit={submit}
                    uploadImages={uploadImages}
                    returnSchema={returnSchema}
                />
            )}
        </div>
    );
};

export default ReturnsContainer;
